import {createFileRoute} from '@tanstack/react-router';
import {HomeLayout} from '@features/flow/components/HomeLayout';
import {TeamView} from '@features/flow/components/TeamView';

export const Route = createFileRoute('/team')({component: TeamPage});

function TeamPage() {
  return (
    <HomeLayout currentView='team'>
      <title>Banani | Team</title>
      <TeamView />
    </HomeLayout>
  );
}
